import { Box, SxProps, Theme } from '@mui/material';
import { columnStyles } from '@/components/content/HdmSkucomparer/styles';

export const Column = ({
	children,
	isVisible = true,
	isMainProduct = false,
	sx,
}: {
	children: React.ReactNode;
	isVisible?: boolean;
	isMainProduct?: boolean;
	sx?: SxProps<Theme>;
}) => (
	<Box
		sx={[
			{
				display: isVisible ? 'flex' : 'none',
				backgroundColor: isMainProduct ? 'grey.50' : undefined,
			},
			columnStyles.container,
			...(Array.isArray(sx) ? sx : [sx]),
		]}
	>
		{children}
	</Box>
);
